import React, { useState, InputHTMLAttributes, useEffect } from 'react';
import { connect, MapStateToProps } from 'react-redux';
import { FieldProps } from 'formik';
import isEmpty from 'lodash/isEmpty';
import { Grid, Typography } from '@inplayer-org/inplayer-ui';

// actions
import { loadExternalAccount as loadExternalAccountAction } from 'ducks/merchantDucks/externalAccount/actions';

// types
import RootState from 'ducks/RootState';
import ExternalAccountState from 'ducks/merchantDucks/externalAccount/types';

// components
import VideoMenu from 'pages/MerchantPages/Assets/Content/components/FormikFields/Panopto/VideoMenu';
import VideoView from 'pages/MerchantPages/Assets/Content/components/FormikFields/Panopto/VideoView';
import Loader from 'pages/MerchantPages/Assets/Content/components/FormikFields/Panopto/Loader';

// constants
import { OvpTypes } from 'pages/MerchantPages/Assets/InitialCreate/OvpVideoType';

const { Container, Cell } = Grid;

interface StateProps {
  externalAccount: ExternalAccountState;
}

interface DispatchProps {
  loadExternalAccount: (ovpName: string) => any;
}

interface OwnProps {}

type Props = InputHTMLAttributes<HTMLInputElement> & FieldProps & StateProps & DispatchProps & OwnProps;

const PanoptoField = ({
  externalAccount: {
    isFetching: externalAccountIsFetching,
    keys: { panopto: { keys: panoptoKeys = null } = { keys: null } },
  },
  loadExternalAccount,
  field: { name, value },
  form: { setFieldValue },
}: Props) => {
  const [isVideoSelected, setVideoSelected] = useState(!isEmpty(value));

  useEffect(() => {
    if (!externalAccountIsFetching) {
      loadExternalAccount(OvpTypes.PANOPTO);
    }
  }, []);

  const switchToVideoBrowsing = () => {
    setVideoSelected(false);
  };

  const setContent = (panoptoContent: Record<string, any>) => {
    setFieldValue(name, panoptoContent);
  };

  if (!panoptoKeys) {
    if (externalAccountIsFetching) {
      return <Loader />;
    }

    return (
      <Container columns={1}>
        <Cell>
          <Typography variant="p">Please connect your Panopto OVP keys</Typography>
        </Cell>
      </Container>
    );
  }

  if (isVideoSelected) {
    return <VideoView value={value} switchToVideoBrowsing={switchToVideoBrowsing} />;
  }

  return <VideoMenu setValue={setContent} />;
};

export const mapStateToProps: MapStateToProps<StateProps, OwnProps, RootState> = (state) => ({
  externalAccount: state.externalAccount,
});

const mappedActionsToProps = {
  loadExternalAccount: loadExternalAccountAction,
};

export default connect(mapStateToProps, mappedActionsToProps)(PanoptoField);
